import { memo } from "react"

import ReactMarkdown from "react-markdown"

import { MessageBubble } from "./styles"

const stripJsonBlocks = (content) => {
   // Strip complete ```json ... ``` blocks
   let stripped = content.replace(/```json\s*[\s\S]*?```/g, "")
   // Strip incomplete/streaming ```json blocks (no closing ``` yet)
   stripped = stripped.replace(/```json[\s\S]*$/g, "")
   return stripped.trim()
}

const ChatMessage = memo(({ message }) => {
   const displayContent = message.role === "assistant" ? stripJsonBlocks(message.content) : message.content

   if (!displayContent) return null

   return (
      <MessageBubble $role={message.role}>
         {message.role === "assistant" ? <ReactMarkdown>{displayContent}</ReactMarkdown> : displayContent}
      </MessageBubble>
   )
})

ChatMessage.displayName = "ChatMessage"

export default ChatMessage
